// extracted by mini-css-extract-plugin
module.exports = {"c1eq60fc":"c1eq60fc","new-tip":"new-tip","c1hdupvx":"c1hdupvx"};